/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const Scribble16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            d="M12.444 12.993c.243-.213.48-.426.677-.62a.761.761 0 00.151.918c.33.304.77.213 1.079-.13.743-.788.854-1.785.302-2.328-.743-.73-1.716-.194-2.656.68-.54.504-.842.808-.973.93.144-.155.512-.562 1.17-1.26 1.5-1.579 2.13-2.918 1.236-3.72-.835-.763-1.986-.097-3.827 1.566-1.551 1.403-2.347 2.166-2.63 1.882-.217-.214.151-.68 2.019-2.736 2.558-2.814 3.636-4.787 2.531-5.77-1.13-1.002-2.44-.123-5.582 2.393-2.176 1.747-3.55 2.607-4.419 3.053-.44.227-.63.654-.46 1.035.178.395.645.518 1.157.265.881-.426 2.433-1.442 4.662-3.234 2.735-2.199 3.301-2.626 3.584-2.347.342.323-.276 1.228-2.65 3.79-2.65 2.846-2.94 3.932-2.071 4.786 1.006.99 2.38.194 4.655-1.856 1.802-1.624 1.913-1.766 2.019-1.656.111.11-.125.285-1.736 2.134-1.27 1.443-1.532 2.27-.875 2.918.605.601 1.466.323 2.637-.693z"
            fill={vars.bdlGray50}
            fillRule="evenodd"
        />
    </AccessibleSVG>
);

export default Scribble16;
